module.exports = __webpack_public_path__ + "img/18_b.40cfd9ef.jpg";